import {
  Banknote,
  BookOpen,
  ClipboardCheck,
  GraduationCap,
  FileText,
  LayoutDashboard,
  UserRound,
  Users,
  UsersRound,
  WalletCards,
} from "lucide-react";

export const SALES_AFFILIATE_LIFECYCLE = Object.freeze({
  REGISTERED_UNVERIFIED: "REGISTERED_UNVERIFIED",
  MANUAL_REVIEW_REQUIRED: "MANUAL_REVIEW_REQUIRED",
  PRE_ACTIVATION: "PRE_ACTIVATION",
  ACTIVE: "ACTIVE",
  DISAPPROVED: "DISAPPROVED",
});

export const SALES_AFFILIATE_WORKSPACE = Object.freeze({
  APPLICATION: "APPLICATION",
  REVIEW: "REVIEW",
  ONBOARDING: "ONBOARDING",
  ACTIVE: "ACTIVE",
  DECISION: "DECISION",
});

const APPLICATION_NAV = [
  {
    section: "Application",
    items: [
      {
        key: "application",
        label: "Application Status",
        to: "/sales-affiliate/application",
        icon: ClipboardCheck,
      },
    ],
  },
];

const DASHBOARD_NAV_SECTION = {
  section: "Dashboard",
  items: [
    {
      key: "dashboard",
      label: "Dashboard",
      to: "/sales-affiliate/dashboard",
      icon: LayoutDashboard,
    },
  ],
};

const COMMERCIAL_NAV_SECTION = {
  section: "Commercial",
  items: [
    {
      key: "prospects",
      label: "Prospects",
      to: "/sales-affiliate/prospects",
      icon: Users,
    },
    {
      key: "subscribers",
      label: "Customers",
      to: "/sales-affiliate/subscribers",
      icon: UsersRound,
    },
    {
      key: "earnings",
      label: "Earnings & Payouts",
      to: "/sales-affiliate/earnings",
      icon: WalletCards,
    },
  ],
};

const LEARNING_NAV_SECTION = {
  section: "Learning",
  items: [
    {
      key: "learning-center",
      label: "Learning Center",
      to: "/sales-affiliate/learning-center",
      icon: BookOpen,
    },
  ],
};

const ONBOARDING_NAV = [
  DASHBOARD_NAV_SECTION,
  COMMERCIAL_NAV_SECTION,
  LEARNING_NAV_SECTION,
  {
    section: "Activation",
    items: [
      {
        key: "onboarding-overview",
        label: "Overview",
        to: "/sales-affiliate/onboarding",
        icon: LayoutDashboard,
      },
      {
        key: "agreement",
        label: "Agreement",
        to: "/sales-affiliate/agreement",
        icon: FileText,
      },
      {
        key: "onboarding-training",
        label: "Assigned Training",
        to: "/sales-affiliate/onboarding#training",
        icon: GraduationCap,
      },
      {
        key: "onboarding-payment",
        label: "Payment Setup",
        to: "/sales-affiliate/onboarding#payment",
        icon: Banknote,
      },
    ],
  },
  {
    section: "Account",
    items: [
      {
        key: "account",
        label: "Account",
        to: "/sales-affiliate/onboarding#account",
        icon: UserRound,
      },
    ],
  },
];

const ACTIVE_NAV = [
  DASHBOARD_NAV_SECTION,
  COMMERCIAL_NAV_SECTION,
  LEARNING_NAV_SECTION,
  {
    section: "Account",
    items: [
      {
        key: "activation-summary",
        label: "Activation Summary",
        to: "/sales-affiliate/onboarding",
        icon: LayoutDashboard,
      },
      {
        key: "agreement",
        label: "Agreement",
        to: "/sales-affiliate/agreement",
        icon: FileText,
      },
    ],
  },
];

export function lifecycleToWorkspaceState(lifecycleState) {
  switch (lifecycleState) {
    case SALES_AFFILIATE_LIFECYCLE.MANUAL_REVIEW_REQUIRED:
      return SALES_AFFILIATE_WORKSPACE.REVIEW;

    case SALES_AFFILIATE_LIFECYCLE.PRE_ACTIVATION:
      return SALES_AFFILIATE_WORKSPACE.ONBOARDING;

    case SALES_AFFILIATE_LIFECYCLE.ACTIVE:
      return SALES_AFFILIATE_WORKSPACE.ACTIVE;

    case SALES_AFFILIATE_LIFECYCLE.DISAPPROVED:
      return SALES_AFFILIATE_WORKSPACE.DECISION;

    case SALES_AFFILIATE_LIFECYCLE.REGISTERED_UNVERIFIED:
    default:
      return SALES_AFFILIATE_WORKSPACE.APPLICATION;
  }
}

export function getWorkspaceConfiguration(lifecycleState) {
  const workspaceState = lifecycleToWorkspaceState(lifecycleState);

  switch (workspaceState) {
    case SALES_AFFILIATE_WORKSPACE.ONBOARDING:
      return {
        workspaceState,
        navigation: ONBOARDING_NAV,
        defaultPath: "/sales-affiliate/onboarding",
        allowsApplicationPage: false,
        allowsOnboardingPage: true,
        allowsDashboardPage: true,
      };

    case SALES_AFFILIATE_WORKSPACE.ACTIVE:
      return {
        workspaceState,
        navigation: ACTIVE_NAV,
        defaultPath: "/sales-affiliate/dashboard",
        allowsApplicationPage: false,
        allowsOnboardingPage: true,
        allowsDashboardPage: true,
      };

    case SALES_AFFILIATE_WORKSPACE.REVIEW:
    case SALES_AFFILIATE_WORKSPACE.DECISION:
    case SALES_AFFILIATE_WORKSPACE.APPLICATION:
    default:
      return {
        workspaceState,
        navigation: APPLICATION_NAV,
        defaultPath: "/sales-affiliate/application",
        allowsApplicationPage: true,
        allowsOnboardingPage: false,
        allowsDashboardPage: false,
      };
  }
}
